import classNames from 'classnames';
import { hexToRgb } from 'helpers/colors';
import React, { useMemo, useState, useEffect } from 'react';

interface AvatarProps {
  name: string;
  image?: string;
  color?: string;
  type?: 'square';
  imageAltText?: string;
  onClick?: () => void;
  fitContent?: boolean;
}

const Avatar = ({ image, imageAltText, name, color, type, onClick, fitContent }: AvatarProps) => {
  const [showAltText, setShowAltText] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAltText(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const bgColor = useMemo(() => {
    if (!color) return undefined;
    const rgb = hexToRgb(color);
    if (rgb) {
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)`;
    }
  }, [color]);

  return (
    <div
      className={classNames('avatar--v2', {
        'avatar--square': type === 'square',
        'avatar--fit-content': fitContent,
        pointer: !!onClick,
      })}
      onClick={onClick}
    >
      {image ? (
        <img
          src={image}
          alt={showAltText ? imageAltText || name : ''}
          title={showAltText ? imageAltText || name : ''}
        />
      ) : (
        <div
          className="avatar-placeholder"
          style={{ color: color, backgroundColor: bgColor }}
          title={showAltText ? imageAltText || name : ''}
        >
          {name[0]}
        </div>
      )}
    </div>
  );
};

export default Avatar;
